module.exports = "/images/avatar.jpg?8cd977c0d11ca2fe693d8e3ca65ecde4";